<template>
    <div>
        <div class="action-table-web" v-if="$detect == 'web'">
            <div class="row">
                <div class="col-2">
                    <ldc-dropdown
                        trigger="click"
                        :action-close="true">
                        <button type="button" class="btn btn-primary btn-time btn-block fs-14px px-1"
                            :disabled="idSelect.length == 0 || loading"
                            >Bán nhanh hơn</button>
                        <ldc-dropdown-menu>
                            <div class="action-checked">
                             <!--    <button class="btn-block btn-dropdown-action border-0 bg-white text-left py-1 px-10px mt-0"
                                    @click="destroy()" close-dropdown v-if="false">Xoá</button> -->
                                <button class="btn-block btn-dropdown-action border-0 bg-white text-left py-1 px-10px mt-0"
                                    @click="upTop()" close-dropdown>Up lên đầu</button>
                                <button class="btn-block btn-dropdown-action border-0 bg-white text-left py-1 px-10px mt-0"
                                    @click="autoUp()" close-dropdown>Up tự động</button>
                                <button class="btn-block btn-dropdown-action border-0 bg-white text-left py-1 px-10px mt-0"
                                    @click="sale()" close-dropdown>Khuyến mãi</button>
                                <!-- <button class="btn-block btn-dropdown-action border-0 bg-white text-left py-1 px-10px mt-0"
                                    @click="upVip('vip')" close-dropdown>Up VIP</button>
                                <button class="btn-block btn-dropdown-action border-0 bg-white text-left py-1 px-10px mt-0"
                                    @click="upVip('supper-vip')" close-dropdown>Up Siêu VIP</button> -->
                            </div>
                        </ldc-dropdown-menu>
                    </ldc-dropdown>
                </div>
                <div class="col-5">
                    <div class="row">
                        <div class="col-5" v-if="showFilterDate">
                            <ldc-dropdown
                                trigger="click"
                                :action-close="true">
                                <button type="button"
                                    class="btn btn-primary btn-time time-date btn-block bg-white fs-14px text-left pl-10px">
                                    <div v-if="this.date.day_form === '' && this.date.day_to === ''">Lọc theo ngày đăng</div>
                                    <div v-else>
                                        <div v-if="showTime">
                                            <div class="text-center">
                                                {{this.$getDate(this.date.day_form)}} <span class="mx-2">-</span> {{this.$getDate(this.date.day_to)}}
                                            </div>
                                        </div>
                                        <div v-else>Lọc theo ngày đăng</div>
                                    </div>
                                </button>
                                <ldc-dropdown-menu>
                                    <div class="fillter-time">
                                        <div class="d-flex">
                                            <div class="w-50 pr-2">
                                                <p class="mb-0 text-label-time mb-1 fs-12px">Từ ngày</p>
                                                <input type="date" class="input-date fs-14px py-1 px-10px" v-model="date.day_form"/>
                                            </div>
                                            <div class="w-50 pl-2">
                                                <p class="mb-0 text-label-time mb-1 fs-12px">Đến ngày</p>
                                                <input type="date" class="input-date fs-14px py-1 px-10px" v-model="date.day_to"/>
                                            </div>
                                        </div>
                                        <div class="d-flex">
                                            <div class="w-75 pr-2">
                                                <div class="btn-confirm-time mt-10px">
                                                    <button class="text-uppercase btn btn-primary btn-block fs-12px"
                                                        close-dropdown
                                                        @click="emitModel(), showTime = true">Áp dụng</button>
                                                </div>
                                            </div>
                                            <div class="w-25 pl-2">
                                                <div class="btn-cancel-time mt-10px">
                                                    <button class="text-uppercase btn btn-block fs-12px"
                                                        close-dropdown
                                                        @click="showTime = false,
                                                                date.day_form = '',
                                                                date.day_to = '',
                                                                emitModel()"
                                                        >xoá</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ldc-dropdown-menu>
                            </ldc-dropdown>
                        </div>
                        <div class="col-6">
                            <ldc-select
                                v-model="data.category"
                                filterable
                                placeholder="Chọn danh mục">
                                <ldc-option
                                    v-for="(item, index) in categories" :key="index"
                                    :value="item.id"
                                    :label="`${item.name} ( ${item.count} )`"/>
                            </ldc-select>
                        </div>
                        <div class="col-6">
                            <ldc-select
                                v-model="data.fillter"
                                placeholder="Lọc">
                                    <ldc-option
                                        v-for="(item, index) in fillters" :key="index"
                                        :value="item.value"
                                        :label="item.name"/>
                            </ldc-select>
                        </div>
                    </div>
                </div>
                <div class="col-5">
                    <div class="row">
                        <div class="col-9">
                            <div class="search position-relative">
                                <input type="text" class="w-100 bg-white fs-14px" placeholder="Nhập tên sản phẩm..."
                                    v-model="keyword" @keyup.enter="enterKeyword()"/>
                                <div class="btn-search position-absolute">
                                    <span class="lable-search px-10px" @click="enterKeyword()">
                                        <i class="icon ion-ios-search fs-20px"></i>
                                    </span>
                                </div>
                               <!--  <div class="text-warning-search fs-10px position-absolute">
                                    * Ghi # để tìm kiếm theo id ( vd: <i>#123456</i> )
                                </div> -->
                            </div>
                        </div>
                        <div class="col-3">
                            <button class="btn btn-block border-0 fs-14px btn-cancel-filter" style="height: 35px;"
                                @click="removeFillter()">Bỏ lọc</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="action-table-mobile">
                <div input-search>
                    <div content-input-search class="search-box position-relative">
                        <input type="text" placeholder="Nhập tên sản phẩm..."
                            v-model="keyword" @keyup.enter="enterKeyword()"/>
                        <div class="text-warning-search fs-10px"> * Tìm kiếm theo tên sản phẩm </div>
                    </div>
                </div>
                <div class="d-flex mb-10px">
                    <div class="w-50 pr-1">
                        <button type="button" class="btn btn-primary btn-action-check btn-block fs-14px px-1"
                            :disabled="idSelect.length == 0 || loading" @click="showActionMuti = true">
                            Bán nhanh hơn
                        </button>
                    </div>
                    <div class="w-50 pl-1">
                        <button type="button" class="btn btn-primary time-date btn-block bg-white fs-14px pl-10px"
                            @click="fillterMobile = true">
                            <i class="icon ion-ios-options fs-18px mr-2"></i>Lọc nâng cao
                        </button>
                    </div>
                </div>
            </div>
            <ldc-model-mobile
                titileCancel="Hủy"
                :showCancel="true"
                :showTitle="true"
                title="Thao tác các mục đã chọn"
                :visible.sync="showActionMuti">
                <ul slot="content-model"
                    :class="{
                        'list-android mb-0': $isAndroid,
                        'list-ios mb-0': !$isAndroid
                    }">
                    <li>
                        <button type="button" class="btn-action-hover btn-block"
                            close-model-mobile @click="upTop()">Up lên đầu</button>
                    </li>
                    <li>
                        <button type="button" class="btn-action-hover btn-block"
                            close-model-mobile @click="autoUp()">Up tự động</button>
                    </li>
                    <li>
                        <button type="button" class="btn-action-hover btn-block"
                            close-model-mobile   @click="sale()">Khuyến mãi</button>
                    </li>
                   <!--  <li>
                        <button type="button" class="btn-action-hover btn-block btn-vip"
                            close-model-mobile @click="upVip('vip')">VIP</button>
                    </li>
                    <li>
                        <button type="button" class="btn-action-hover btn-block btn-svip"
                            close-model-mobile @click="upVip('supper-vip')">SIÊU VIP</button>
                    </li>
                    <li>
                        <button type="button" class="btn-action-hover btn-remove btn-block"
                            close-model-mobile @click="destroy()" v-if="false">Xoá</button>
                    </li> -->
                </ul>
            </ldc-model-mobile>
            <ldc-model-mobile
                titileCancel="Hủy"
                :showCancel="false"
                :showTitle="true"
                title="Lọc sản phẩm"
                :customButton="true"
                :visible.sync="fillterMobile">
                <div slot="content-model"
                    :class="{
                        'fillter-android': $isAndroid,
                        'fillter-ios': !$isAndroid,
                    }">
                    <div class="item-fillter" role="button">
                        <ldc-select-mobile
                            placeholder="Chọn danh mục"
                            title="Lọc theo danh mục"
                            v-model="data.category">
                            <ldc-option-mobile
                                v-for="(item, index) in categories" :key="index"
                                :value="item.id"
                                :label="`${item.name} (${item.count})`"/>
                        </ldc-select-mobile>
                    </div>
                    <div class="item-fillter" role="button">
                        <ldc-select-show-option
                            v-model="data.fillter"
                            placeholder="Loại tin">
                            <ldc-option-show
                                v-for="(item, index) in fillters" :key="index"
                                :value="item.value"
                                :label="item.name"/>
                        </ldc-select-show-option>
                    </div>
                    <div class="fillter-date text-left mt-3" v-if="showFilterDate">
                        <div class="tilte-date px-10px pb-2">
                            Lọc theo ngày đăng
                        </div>
                        <div class="fillter">
                            <div class="d-flex">
                                <div class="w-50 pl-10px pr-10px">
                                    <p class="mb-0 text-label-time fs-12px">Từ ngày</p>
                                    <input type="date" class="input-date fs-14px py-1 px-10px"
                                        :placeholder="date.day_form !== '' ? '' : 'Chọn ngày'"
                                        v-model="date.day_form"/>
                                </div>
                                <div class="w-50 pr-10px pl-10px">
                                    <p class="mb-0 text-label-time fs-12px">Đến ngày</p>
                                    <input type="date" class="input-date fs-14px py-1 px-10px"
                                        :placeholder="date.day_to !== '' ? '' : 'Chọn ngày'"
                                        v-model="date.day_to"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div slot="custom-buttom"
                    :class="{
                        'fillter-android': $isAndroid,
                        'fillter-ios': !$isAndroid,
                    }">
                    <div :class="{
                        'btn-confirm-android': $isAndroid,
                        'btn-confirm-ios mb-10px': !$isAndroid
                        }">
                        <button class="btn btn-primary radius-ios text-uppercase mr-10px fs-14px btn-apply"
                            @click="emitModel()" close-model-mobile>áp dụng</button>
                        <button class="btn btn-light radius-ios text-uppercase ml-10px fs-14px btn-cancel"
                            @click="removeFillter()" close-model-mobile>Bỏ lọc</button>
                    </div>
                </div>
            </ldc-model-mobile>
        </div>
        <actionDialog
            :multiple="true"
            :action="action"
            :visible.sync="dialog"
            :dataMultiple="idSelect"/>
    </div>
</template>
<script>
import { upTop, availability, destroy } from '@/config/raovat';
export default {
    props: ['value', 'idSelect'],
    components: {
        actionDialog: () => import('@/components/profile/raovat/actionDialog.vue'),
    },
    data(){
        return {
            categories: [],
            fillters: [
                { 
                    name: 'SP nổi bật',
                    value: 'hot' 
                },
                { 
                    name: 'SP mới',
                    value: 'new' 
                },
                { 
                    name: 'SP không duyệt',
                    value: 'do_not_browse' 
                },
                { 
                    name: 'SP chờ duyệt',
                    value: 'pending' 
                },
                { 
                    name: 'SP khuyến mại',
                    value: 'promotion' 
                },
                // { 
                //     name: 'SP rẻ nhất',
                //     value: 'price_cut' 
                // },
                // { 
                //     name: 'SP hết hàng',
                //     value: 'out_of_stock' 
                // },
                // { 
                //     name: 'SP sắp hết hàng',
                //     value: 'out_of_stock_1' 
                // },
                // { 
                //     name: 'SP có gắn link',
                //     value: 'has_other_link' 
                // }    
                
            ],
            data: {
                fillter     :  '',
                category : '',
            },
            date: {
                day_form: '',
                day_to: '',
            },
            keyword: this.$route.query.keyword,
            showTime: false,
            showActionMuti: false,
            fillterMobile: false,
            dialog: false,
            action: '',
            showFilterDate: false,
            loading: false,
        }
    },
    watch: {
        data:{
            handler(val){
                if(this.$detect == 'web'){
                    this.emitModel();
                }
            },
            deep: true,
        },
        value: {
            handler(val){
                this.changeValue();
            },
            deep: true,
        }
    },
    created() {
        this.changeValue();
        apiGet('/v2/profile/products/group_category').then(res => {
            this.categories = res.data;
        })
    },
    methods: {
        changeValue(){
            if(this.value.new != '') this.data.fillter = 'new';
            if(this.value.hot != '') this.data.fillter = 'hot';
            if(this.value.promotion != '') this.data.fillter = 'promotion';
            if(this.value.price_cut != '') this.data.fillter = 'price_cut';
            if(this.value.out_of_stock != '') this.data.fillter = 'out_of_stock';
            if(this.value.out_of_stock_1 != '') this.data.fillter = 'out_of_stock_1';
            if(this.value.has_other_link != '') this.data.fillter = 'has_other_link';
            if(this.value.pending != '' && this.value.pending == 0) this.data.fillter = 'pending';
            if(this.value.pending != '' && this.value.pending == 2) this.data.fillter = 'do_not_browse';
            this.data.category = this.value.category ? this.value.category : '';
        },
        enterKeyword(){
            if(this.keyword.length < 3 && this.keyword.length > 0) return;
            this.emitModel();
        },
        emitModel(){
            let pending = '';
            switch(this.data.fillter) {
                case 'pending':
                    pending = 0;
                    break;
                case 'do_not_browse':
                    pending = 2;
                    break;
                default:
                    pending = '';
                    break;
            }
            let data = {
                hot     :   this.data.fillter == 'hot' ? 1 : '',
                new     :   this.data.fillter == 'new' ? 1 : '',
                promotion   :   this.data.fillter == 'promotion' ? 1 : '',
                out_of_stock_1  :  this.data.fillter == 'out_of_stock_1' ? 1 : '',
                out_of_stock    :   this.data.fillter == 'out_of_stock' ? 1 : '',
                price_cut   :  this.data.fillter == 'price_cut' ? 1 : '',
                has_other_link  :   this.data.fillter == 'has_other_link' ? 1 : '',
                pending  :   pending,
                category    : this.data.category,
                keyword     : this.keyword,
            }

            if(this.data.page) data.page = this.data.page;
            this.$emit('input', data)
        },
        upVip(action){
            this.action = action;
            this.dialog = true;
        },
        async destroy(){
            this.loading = true;
            await destroy(this.idSelect, this);
            this.loading = false;
        },
        async availability(){
            this.loading = true;
            await availability(this.idSelect, this);
            this.loading = false;
        },
        async upTop(){
            this.loading = true;
            await upTop(this.idSelect, this);
            this.loading = false;
        },
        autoUp(){
            let query = '';
            this.idSelect.map((item, index) => {
                if(index == 0){
                    query += item
                }else{
                    query += ','+item
                }
            })
            this.$router.push({
                name: 'product-auto-up',
                query: {
                    id: query
                }
            })
        },
        sale(){
            let query = '';
            this.idSelect.map((item, index) => {
                if(index == 0){
                    query += item
                }else{
                    query += ','+item
                }
            })
            this.$router.push({
                name: 'product-action-product-sale',
                query: {
                    id: query
                }
            })
        },
        removeFillter(){
            this.data = {
                category: '',
                fillter: '',
            }
            this.date = {
                day_form: '',
                day_to: '',
            }
            this.keyword = '';
            this.emitModel();
        },
    },
}
</script>
